import React, { ReactNode } from "react";
import { Offcanvas } from "react-bootstrap";

interface SlidePanelProps {
  open: boolean;
  onClose: () => void;
  title: string;
  width?: string;
  children: ReactNode;
  footer?: ReactNode;
}

const SlidePanel: React.FC<SlidePanelProps> = ({
  open,
  onClose,
  title,
  width = "400px",
  children,
  footer,
}) => {
  if (!open) return null;

  return (
    <Offcanvas show={open} onHide={onClose} placement="end" style={{ width }}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="d-flex flex-column p-0">
        <div className="flex-grow-1 overflow-auto p-3">{children}</div>
        {footer && (
          <div className="d-flex flex-wrap justify-content-end gap-2 border-top p-3">
            {footer}
          </div>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default SlidePanel;
